import React from 'react';
import './cardBody.css';

const CardBody= ({children}) => (
  <div className="cardBody">
      {children}
  </div>
);

export default CardBody;
